import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  // Ensure every authenticated page emits `<meta name="robots" content="noindex,nofollow">`
  // so private/user-specific screens (dashboard, project view, account, etc.) never end up
  // in search results.
  useEffect(() => {
    let el = document.querySelector('meta[name="robots"]');
    const prev = el?.getAttribute('content');
    const created = !el;
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute('name', 'robots');
      document.head.appendChild(el);
    }
    el.setAttribute('content', 'noindex, nofollow');
    return () => {
      if (created) el.remove();
      else if (prev != null) el.setAttribute('content', prev);
    };
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0D0D0D] flex items-center justify-center">
        <p className="text-[#A0A0A0] font-heading text-xl animate-pulse">Loading frame...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  return children;
}
